import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Checkbox, Modal } from '@reveni-io/reveni-ui'

import { getShipmentDeclaration } from '@/common/helpers/shipmentDeclaration/helpers'
import DiscardLabelsCheckbox from '@/returns/components/DiscardLabelsCheckbox/DiscardLabelsCheckbox'

import { hasDiscardableLabels } from '../helpers'
import useGenerateLabelModal from './hooks/useGenerateLabelModal/useGenerateLabelModal'
import ShipmentItemsList from './ShipmentItemsList/ShipmentItemsList'
import * as Styles from './styles'

const GenerateLabelModal = ({
  show,
  onClose,
  onGenerateLabel,
  loading,
  lineItems,
  lineItemGroups,
  includesRejectedItems,
  returnLabels,
}) => {
  const { t } = useTranslation()
  const { includeRejectedItems, handleChangeIncludeRejectedItems, discardLabels, handleChangeDiscardLabels } =
    useGenerateLabelModal({
      show,
      includesRejectedItems,
    })

  const { includedItems, rejectedCount, isAllRejected, isPartiallyRejected, declaresRejectedItems } =
    getShipmentDeclaration({ lineItems, lineItemGroups, includeRejectedItems })

  const showDiscardLabels = hasDiscardableLabels(returnLabels)

  const handleToggleIncludeRejectedItems = e => handleChangeIncludeRejectedItems(e.target.checked)

  const handleAccept = () => onGenerateLabel({ includeRejectedItems: declaresRejectedItems, discardLabels })

  return (
    <Modal show={show} onClose={onClose} size="l" title={t('Crear etiqueta de envío')}>
      <Styles.Container>
        {isAllRejected && (
          <Alert type="warning">
            {t(
              'Todos los productos de esta transacción han sido rechazados. La etiqueta de envío se creará incluyendo todos los artículos listados a continuación.'
            )}
          </Alert>
        )}
        {isPartiallyRejected && (
          <>
            <Alert type="warning">
              {t(
                'Esta transacción contiene {{count}} producto(s) rechazado(s). Por defecto, la etiqueta de envío solo incluirá los artículos aceptados.',
                { count: rejectedCount }
              )}
            </Alert>
            <Checkbox
              label={t('Incluir productos rechazados en este envío.')}
              checked={includeRejectedItems}
              onChange={handleToggleIncludeRejectedItems}
            />
          </>
        )}
        <ShipmentItemsList items={includedItems} />
        {showDiscardLabels && <DiscardLabelsCheckbox checked={discardLabels} onChange={handleChangeDiscardLabels} />}
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            onClick={handleAccept}
            loading={loading}
            disabled={loading || !includedItems.length}
            defaultLabel={t('Crear etiqueta')}
            loadingLabel={t('Crear etiqueta')}
          />
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default GenerateLabelModal
